export default {"src":"/_next/static/media/ra-maintainance.3381d085.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};